import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row pt-5">
          <div className="col-lg-3 col-md-3 col-sm-6 col-12">
            <div className="footer-menus">
              <div className="">
                <Link to="#">
                  <img
                    className="mr-3"
                    src="/images/footer/visa.png"
                    height="40"
                    alt="Footer Logo"
                  />
                </Link>
                <Link to="#">
                  <img
                    src="/images/footer/master.png"
                    height="40"
                    alt="Footer Logo"
                  />
                </Link>
              </div>

              <h5 className="mt-5">Follow us</h5>

              <div className="div-footer-social">
                <Link
                  to={{
                    pathname:
                      'https://www.facebook.com/RoadJockeyja-216857437001890',
                  }}
                  target="_blank"
                >
                  <i className="fab fa-facebook"></i>
                </Link>

                <Link to="#">
                  <i className="fab fa-youtube"></i>
                </Link>

                <Link
                  to={{ pathname: 'https://twitter.com/roadjockeyja' }}
                  target="_blank"
                >
                  <i className="fab fa-twitter"></i>
                </Link>

                <Link
                  to={{ pathname: 'https://www.instagram.com/roadjockey.ja' }}
                  target="_blank"
                >
                  <i className="fab fa-instagram"></i>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-12">
            <div className="footer-menus">
              <ul>
                <li>
                  <a href="/careers">Careers</a>
                </li>
                <li>
                  <a href="/partners">Store Partners</a>
                </li>
                <li>
                  <a href="/roadies">Roadies</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-12">
            <div className="footer-menus">
              <ul>
                <li>
                  <a href="/about">About Us</a>
                </li>
                <li>
                  <a href="/faqs">FAQ</a>
                </li>
                <li>
                  <a href="/contact">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-6 col-12">
            <div className="footer-menus">
              <ul>
                <li>
                  <a href="/termsandconditions">Terms & Conditions</a>
                </li>
                <li>
                  <a href="/privacypolicy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/cookiespolicy">Cookies Policy</a>
                </li>
                <li>
                  <a href="/refundpolicy">Refund Policy</a>
                </li>
                <li>
                  <a href="/disclaimer">Disclaimer</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p style={{ textAlign: 'center', color: 'white' }}>
          © Copyright 2022 RoadJockey . All Rights Reserved{' '}
        </p>
      </div>
    </footer>
  )
}

export default Footer
